/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { GawdOwners, GawdOwnersInterface } from "../GawdOwners";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OwnerAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "OwnerRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint16[]",
        name: "gawdIds",
        type: "uint16[]",
      },
      {
        internalType: "address[]",
        name: "newOwners",
        type: "address[]",
      },
    ],
    name: "bulkUpdateGawdOwners",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "gawdOwners",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "gawdsByOwner",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "gawdsCountForOwner",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "gawdsForOwner",
    outputs: [
      {
        internalType: "uint16[]",
        name: "",
        type: "uint16[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
    ],
    name: "hasOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "myGawdsCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
    ],
    name: "ownerForGawd",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "owners",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ownersCount",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
    ],
    name: "removeGawdOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "setGawdOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "updateGawdOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b5061001a3361001f565b61006f565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b610f538061007e6000396000f3fe608060405234801561001057600080fd5b50600436106101005760003560e01c8063af152e4f11610097578063c4bdd77a11610066578063c4bdd77a14610296578063d019d0c51461029e578063dfa669cc146102b1578063f2fde38b146102c457600080fd5b8063af152e4f14610203578063b89c925014610216578063b948854614610236578063bc916a501461025757600080fd5b806381196458116100d357806381196458146101655780638da5cb5b1461019c5780639ff256fc146101ad578063ab51ebbf146101da57600080fd5b8063025e7c2714610105578063697a88c514610135578063715018a61461014a57806377aa676814610152575b600080fd5b610118610113366004610d68565b6102d7565b6040516001600160a01b0390911681526020015b60405180910390f35b610148610143366004610d35565b610301565b005b61014861036d565b610148610160366004610d35565b6103a3565b61018e610173366004610c07565b6001600160a01b031660009081526003602052604090205490565b60405190815260200161012c565b6000546001600160a01b0316610118565b6101186101bb366004610d1a565b61ffff166000908152600460205260409020546001600160a01b031690565b6101186101e8366004610d1a565b6004602052600090815260409020546001600160a01b031681565b610148610211366004610c53565b61050f565b610229610224366004610c07565b6105f7565b60405161012c9190610d81565b6002546102449061ffff1681565b60405161ffff909116815260200161012c565b610286610265366004610d1a565b61ffff166000908152600460205260409020546001600160a01b0316151590565b604051901515815260200161012c565b61018e61068b565b6101486102ac366004610d1a565b61069b565b6102446102bf366004610c29565b610a2e565b6101486102d2366004610c07565b610a75565b600181815481106102e757600080fd5b6000918252602090912001546001600160a01b0316905081565b6000546001600160a01b031633146103345760405162461bcd60e51b815260040161032b90610dc9565b60405180910390fd5b61ffff82166000908152600460205260409020546001600160a01b03161561035f5761035f8261069b565b61036982826103a3565b5050565b6000546001600160a01b031633146103975760405162461bcd60e51b815260040161032b90610dc9565b6103a16000610b10565b565b6000546001600160a01b031633146103cd5760405162461bcd60e51b815260040161032b90610dc9565b61ffff82166000908152600460205260409020546001600160a01b0316156104375760405162461bcd60e51b815260206004820152601a60248201527f74686973206761776420697320616c7265616479206f776e6564000000000000604482015260640161032b565b6001600160a01b038116600081815260036020908152604080832080546001810182559084528284206010820401805461ffff808a166002600f90951685026101000a81810290830219909316929092179092558552600490935290832080546001600160a01b03191690941790935582541691906104b583610e88565b91906101000a81548161ffff021916908361ffff16021790555050806001600160a01b03168261ffff167f65d8c7f544d7f390fa03c2c85d8bd42bfa2c4eba10474a89129aaa631677793860405160405180910390a35050565b6000546001600160a01b031633146105395760405162461bcd60e51b815260040161032b90610dc9565b80518251146105985760405162461bcd60e51b815260206004820152602560248201527f6e6565642073616d65206e756d626572206f662069647320616e642061646472604482015264657373657360d81b606482015260840161032b565b60005b82518110156105f2576105e08382815181106105b9576105b9610ef1565b60200260200101518383815181106105d3576105d3610ef1565b6020026020010151610301565b806105ea81610eaa565b91505061059b565b505050565b6001600160a01b03811660009081526003602090815260409182902080548351818402810184019094528084526060939283018282801561067f57602002820191906000526020600020906000905b82829054906101000a900461ffff1661ffff16815260200190600201906020826001010492830192600103820291508084116106465790505b50505050509050919050565b600061069633610173565b905090565b6000546001600160a01b031633146106c55760405162461bcd60e51b815260040161032b90610dc9565b61ffff81166000908152600460205260409020546001600160a01b03166107275760405162461bcd60e51b81526020600482015260166024820152753a3434b99033b0bbb2103430b99037379037bbb732b960511b604482015260640161032b565b61ffff8116600090815260046020526040812080546001600160a01b031981169091556001600160a01b031690805b6001600160a01b0383166000908152600360205260409020548110156109b1576001600160a01b0383166000908152600360205260409020805461ffff86169190839081106107a7576107a7610ef1565b60009182526020909120601082040154600f9091166002026101000a900461ffff16141561099f576001600160a01b03831660009081526003602052604090208054829081106107f9576107f9610ef1565b600091825260208083206010830401546001600160a01b0387168452600390915260409092208054600f9092166002026101000a90920461ffff16935061084290600190610e53565b8154811061085257610852610ef1565b90600052602060002090601091828204019190066002029054906101000a900461ffff1660036000856001600160a01b03166001600160a01b0316815260200190815260200160002082815481106108ac576108ac610ef1565b6000918252602080832060108304018054600f9093166002026101000a61ffff8181021990941695909316929092029390931790556001600160a01b0385168152600390915260409020805461090490600190610e53565b8154811061091457610914610ef1565b90600052602060002090601091828204019190066002026101000a81549061ffff021916905560036000846001600160a01b03166001600160a01b0316815260200190815260200160002080548061096e5761096e610edb565b600082815260209020601060001990920191820401805461ffff6002600f8516026101000a021916905590556109b1565b806109a981610eaa565b915050610756565b506002805461ffff169060006109c683610e6a565b91906101000a81548161ffff021916908361ffff16021790555050816001600160a01b03168361ffff167fc0583cef9f726fb98ff6923a0d933e0d432acdec8889feec72f9a5286d7c4b2183604051610a2191815260200190565b60405180910390a3505050565b60036020528160005260406000208181548110610a4a57600080fd5b9060005260206000209060109182820401919006600202915091509054906101000a900461ffff1681565b6000546001600160a01b03163314610a9f5760405162461bcd60e51b815260040161032b90610dc9565b6001600160a01b038116610b045760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b606482015260840161032b565b610b0d81610b10565b50565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b80356001600160a01b0381168114610b7757600080fd5b919050565b600082601f830112610b8d57600080fd5b81356020610ba2610b9d83610e2f565b610dfe565b80838252828201915082860187848660051b8901011115610bc257600080fd5b60005b85811015610be857610bd682610b60565b84529284019290840190600101610bc5565b5090979650505050505050565b803561ffff81168114610b7757600080fd5b600060208284031215610c1957600080fd5b610c2282610b60565b9392505050565b60008060408385031215610c3c57600080fd5b610c4583610b60565b946020939093013593505050565b60008060408385031215610c6657600080fd5b823567ffffffffffffffff80821115610c7e57600080fd5b818501915085601f830112610c9257600080fd5b81356020610ca2610b9d83610e2f565b8083825282820191508286018a848660051b8901011115610cc257600080fd5b600096505b84871015610cec57610cd881610bf5565b835260019690960195918301918301610cc7565b5096505086013592505080821115610d0357600080fd5b50610d1085828601610b7c565b9150509250929050565b600060208284031215610d2c57600080fd5b610c2282610bf5565b60008060408385031215610d4857600080fd5b610d5183610bf5565b9150610d5f60208401610b60565b90509250929050565b600060208284031215610d7a57600080fd5b5035919050565b6020808252825182820181905260009190848201906040850190845b81811015610dbd57835161ffff1683529284019291840191600101610d9d565b50909695505050505050565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b604051601f8201601f1916810167ffffffffffffffff81118282101715610e2757610e27610f07565b604052919050565b600067ffffffffffffffff821115610e4957610e49610f07565b5060051b60200190565b600082821015610e6557610e65610ec5565b500390565b600061ffff821680610e7e57610e7e610ec5565b6000190192915050565b600061ffff80831681811415610ea057610ea0610ec5565b6001019392505050565b6000600019821415610ebe57610ebe610ec5565b5060010190565b634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052603160045260246000fd5b634e487b7160e01b600052603260045260246000fd5b634e487b7160e01b600052604160045260246000fdfea264697066735822122010166f949b2df2895705a47e30f439a2cad14ffff65e0aa73c63ff2819cfbc4f64736f6c63430008070033";

type GawdOwnersConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GawdOwnersConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GawdOwners__factory extends ContractFactory {
  constructor(...args: GawdOwnersConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "GawdOwners";
  }

  override deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<GawdOwners> {
    return super.deploy(overrides || {}) as Promise<GawdOwners>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): GawdOwners {
    return super.attach(address) as GawdOwners;
  }
  override connect(signer: Signer): GawdOwners__factory {
    return super.connect(signer) as GawdOwners__factory;
  }
  static readonly contractName: "GawdOwners";

  public readonly contractName: "GawdOwners";

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GawdOwnersInterface {
    return new utils.Interface(_abi) as GawdOwnersInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GawdOwners {
    return new Contract(address, _abi, signerOrProvider) as GawdOwners;
  }
}
